import { Flex, FlexProps } from '@chakra-ui/react';
import { BookingQueueDetailsTabs } from './components/BookingQueueDetailsTabs';

const BookingQueueDetailsData = (props: FlexProps): JSX.Element => (
  <Flex
    direction="column"
    w="100%"
    borderRadius={8}
    bg="white"
    p="8"
    {...props}
  >
    <BookingQueueDetailsTabs />
  </Flex>
);

export default BookingQueueDetailsData;
